module.exports = __webpack_public_path__ + "static/media/instagram.b777c175.jpg";